<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Recipes on the Radio</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Radio show, web design, streaming, cooking</p>
        <p>Recipes on the Radio is a radio show streamed on WORM Radio and recorded mostly in the WORM kitchen. It features discussions about food and it's implication in society and culture, bringing together the hosts, Alice Strete and Yoana Buzova, as well as several guests throughout the show.</p>
        <p>The recording of the show, as well as the recipes that we cooked in each episode can be found on the <a href="https://vvvvvvaria.org/~strt/radio/">website</a>.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/ROR.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/ror/santi.jpg"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/ror/radio.jpeg"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/ror/sandwiches.jpg"></b-img>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'RORPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
